import { useDesignReferences } from "./useDesignReferences";

type DesignReferencesCountResult = {
  total: number;
};

export const useDesignReferencesCount = (
  designId: string
): DesignReferencesCountResult => {
  const { data: designReferences } = useDesignReferences(designId);

  return { total: designReferences?.mapping_list?.length || 0 };
};
